<template>
    <ui-modal-message-v-2
        name="bulk-responsible-step-modal"
        :cancel-button="false"
        :close-button="closeIcon"
        :color-square="colorSquareHandle"
        :close-custom-event-name="'close-bulk-step'"
        icon-square
        :dynamic-icon="'ui-funnil'"
        :width-dynamic-icon="24"
        :height-dynamic-icon="16"
        v-on="$listeners"
    >

        <template #title>
            <div class="header-container">
                <span class="first-title">Alteração de Responsável</span>
                <p class="second-title">
                    <span 
                        class="blue-text" 
                        :class="{ 'blue-text-paused': isPaused && !handleError }"
                    >
                        {{ responsible?.name || 'Responsável' }}
                    </span>
                    da equipe  
                    <span 
                        v-if="responsible?.team_name" 
                        class="blue-text"
                        :class="{ 'blue-text-paused': isPaused && !handleError }"
                    >
                        {{ responsible?.team_name }}
                    </span>
                    será responsável {{deals.length > 1 ? ' pelos ' : ' pelo '}}
                    <span 
                        class="blue-text" 
                        :class="{ 'blue-text-paused': isPaused && !handleError }">
                        {{ deals.length > 1 ? deals.length : "" }} {{deals.length > 1 ? 'negócios' : 'negócio'}}
                    </span> 
                    {{deals.length > 1 ? ' selecionados ' : ' selecionado '}}
                </p>
                <div class="diviser"/>
            </div>
        </template>
    
        <template #text>
            <div v-if="handleError" class="error-container">
                <uiCircleX width="26" height="26"/>
                <span class="error-text">
                    Um erro inesperado aconteceu: {{ errorMessage }}. O processo foi interrompido.
                </span>
            </div>

            <div v-else-if="finished" class="finished-container">
                <ui-circle-v :design="'mr10px'" width="26" height="26" />
                <span class="finished-text">Alteração concluída com sucesso!</span>
            </div>
            <div v-else class="text-container">  
                <span>
                    <strong>{{ currentIndex }}</strong> de
                    <strong>{{ totalDeals }}</strong> negócios selecionados.
                </span>
                <uiProgressBar
                    :current="currentIndex"
                    :total="totalDeals"
                    :is-paused-computed="isPaused"
                />
            </div>
        </template>
    
        <template #footer>
            <div class="footer-container">
                <div >
                    <div v-if="handleError" class="footer-text-error">
                        <uiSuportIcon width="19" height="21"/>
                        <span>Se o erro persistir, entre em <strong>contato com o suporte.</strong></span>
                    </div>
                    <span v-else-if="isPaused ">Ação pausada. Feche este modal para interromper.</span>
                    <div v-else-if="isProcessing" class="footer-text">
                        <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="26" :stroke="8" />
                        <span>Espere. Estamos finalizando.</span>
                    </div>
                </div>
                <ui-button v-if="finished || handleError" @click="closeBulkModal">
                    Sair
                </ui-button>
                <ui-button 
                    v-else  
                    :disabled="isLastCall"
                    :design="isPaused ? 'md success' : 'md primary'" 
                    @click="togglePause"
                >
                    {{ isPaused ? 'Continuar' : 'Pausar' }}
                </ui-button>
            </div>
        </template>
    </ui-modal-message-v-2>
</template>
    
    <script>
    import { uiModalMessageV2 } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'
    import { uiProgressBar } from '@/components/ui'
    import { funnel } from '@/services/axios'
    import { uiCircleX, uiSuportIcon } from '@/components/ui-icons'
    import { uiLoadIndicator } from '@/components/ui'

    export default {
        name: 'bulk-responsible-step',
        components: {
            uiModalMessageV2,
            uiButton,
            uiProgressBar,
            uiSuportIcon,
            uiCircleX,
            uiLoadIndicator
        },
        props: {
        deals: {
            type: Array,
            default: () => []
        },
        stageId: {
            type: [String, Number],
            default: null
        },
        stageStatusId: {
            type: [String, Number],
            default: null
        },
        responsible: {
                    type: Object,
                    required: true
                }
        },
        data() {
            return {
                isProcessing: false,
                isPaused: false,
                currentIndex: 0,
                totalDeals: 0,
                finished: false,
                handleError: false,
                errorMessage: "",
                closeIcon: false,
                inheritAttrs: false,              
            }
        },

        computed: {
            progressValue() {
            if (!this.totalDeals) return 0
                return Math.round((this.currentIndex / this.totalDeals) * 100)
            },
            colorSquareHandle(){
                if(this.handleError){
                    return 'danger'
                }
                else if(this.isPaused){
                    return 'stoped'
                }
                else {
                    return 'primary'
                }
            },
            isLastCall() {
                return this.currentIndex >= this.totalDeals
            },
        },
        mounted() {
            this.$root.$on('modal-msg-open-bulk-responsible-step-modal', () => {
                this.closeIcon = false
                this.$nextTick(() => {
                    this.startProcess()
                })
            })
        },

        
         beforeDestroy() {
           this.$root.$off('modal-msg-open-bulk-responsible-step-modal')
         },

        methods: {
            closeBulkModal() {
                this.$emit('close-bulk-step')
                this.$root.$emit('modal-msg-close-bulk-responsible-step-modal')


                // resetar para nova execução
                this.currentIndex = 0
                this.totalDeals = 0
                this.isProcessing = false
                this.isPaused = false
                this.finished = false
                this.closeIcon = false
            }, 

            async startProcess() {
                this.totalDeals = this.deals.length
                this.currentIndex = 1
                this.isProcessing = true
                this.isPaused = false
                this.handleError = false
                
                // Dispara a primeira chamada do loop
                await this.processNext()
            },

            // Avança para o próximo negócio, enquanto não estiver pausado ou terminado
            async processNext() {
               if (this.currentIndex > this.totalDeals) {
                   this.isProcessing = false
                   this.finished = true
                   return
               }

               if (this.isPaused) return

               // Pega o deal atual
               const deal = this.deals[this.currentIndex - 1]
               const payload = {
                    users: [this.responsible.id],
                    changeResponsibleCustomer: this.responsible.changeResponsibleCustomer
                }

                funnel.updateResponsible(deal.id, payload)
                    .then(() => {
                    if (!this.isPaused) {
                        this.currentIndex++
                        this.processNext()
                    }
                }).catch((error) => {
                    this.isProcessing = false
                    this.handleError = true
                    this.errorMessage = error?.data?.msg || 'Erro desconhecido.'
        })
            },

            // Alterna entre "Pausar" e "Retomar"
            togglePause() {
                if (!this.isProcessing) return

                if (!this.isPaused) {
                    this.isPaused = true
                    this.closeIcon = true
                } else {
                    this.isPaused = false
                    this.closeIcon = false
                    // Chama o próximo da fila
                    this.processNext()
                }
            }
            }
        }
    </script>

    <style lang="stylus" scoped>
        @import './styles.styl';
    </style>    